import { MaterialDateConfirmationMilestone } from "../types";

export function getMaximumUpstreamActualDate(
  milestones: Pick<MaterialDateConfirmationMilestone, "actualDate">[],
  index: number
): string | null {
  let maximumActualDate: string | null = null;

  for (let upstreamIndex = 0; upstreamIndex < index; upstreamIndex += 1) {
    const actualDate = milestones[upstreamIndex].actualDate;
    if (actualDate && (!maximumActualDate || actualDate > maximumActualDate)) {
      maximumActualDate = actualDate;
    }
  }

  return maximumActualDate;
}

export function isMilestoneActualDateInvalid(
  milestone: Pick<MaterialDateConfirmationMilestone, "actualDate">,
  maximumUpstreamActualDate: string | null
): boolean {
  if (!milestone.actualDate) {
    return false;
  }

  if (!maximumUpstreamActualDate) {
    return false;
  }

  return milestone.actualDate < maximumUpstreamActualDate;
}

export function getActualDateErrorMilestoneIds(
  milestones: MaterialDateConfirmationMilestone[]
): Set<string> {
  const errorIds = new Set<string>();

  for (let index = 1; index < milestones.length; index += 1) {
    const milestone = milestones[index];
    const maximumUpstreamActualDate = getMaximumUpstreamActualDate(
      milestones,
      index
    );

    if (isMilestoneActualDateInvalid(milestone, maximumUpstreamActualDate)) {
      errorIds.add(milestone.id);
    }
  }

  return errorIds;
}

export function hasActualDateOrderErrors(
  milestones: MaterialDateConfirmationMilestone[]
): boolean {
  return getActualDateErrorMilestoneIds(milestones).size > 0;
}
